import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'withLabels',
    standalone: true
})
export class WithLabelsPipe implements PipeTransform {

    transform<T, Q>(items: T[], filter: Q[], type: string): any {
        // console.log(items, filter, type)
        if (!filter || !items) {
            return items;
        }
        const program_selected = filter['program'] && filter['program'].reduce((acc, cur) => acc || cur.checked, false);
        const session_selected = filter['session'] && filter['session'].length > 0;
        if (type === 'program_single') {
            items = items.filter(item => (!program_selected || filter['program'].findIndex(p => p.checked && p.id === item['pID']) > -1) &&
                (!session_selected || filter['session'].reduce((acc, cur) => acc || item['sess_labels'].indexOf(cur) > -1, false)));
        } else if (type === 'program_multiple') {
            items = items.filter(item => !program_selected || filter['program'].findIndex(p => p.checked && p.id === item['pID']) > -1);
        } else if (type === 'session') {
            items = items.filter(item => !session_selected || filter['session'].reduce((acc, cur) => acc || item['sess_labels'].indexOf(cur) > -1, false));
        }
        return items.length === 0 ? [undefined] : items;
    }
}
